import { Box, Button, Container, Divider, Grid, Input, Radio, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography } from "@mui/material"
import Bottom from "../../Bottom";
import { useEffect, useState } from "react";
import api from "../../../utils/api";

import { useLocation, useNavigate } from "react-router-dom";

import tabbg from "../../../assets/images/tab_01.png"

import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import useHraStore from "../../../store/hraStores";



import ButtonBase from '@mui/material/ButtonBase';
import { styled } from '@mui/material/styles';
import reimg1 from "../../../assets/images/reimg1.png";
import reimg2 from "../../../assets/images/reimg2.png";
import reimg3 from "../../../assets/images/reimg3.png";

import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import { relative } from "path";


const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

// 새로고침 이미지 변경
const ImgArr = [reimg1, reimg3,];
const randomIndex = Math.floor(Math.random() * ImgArr.length);
const reTopImg = ImgArr[randomIndex];


const HraResult = () => {

  const storeData: any = useHraStore();
  const navigate = useNavigate();
  const location = useLocation();

  // 탭 관련 useState
  const [value, setValue] = useState(0);
  const handleTabChange = (_: any, newValue: any) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (!!!location.state) navigate('/survey/hra')
    else getQuestionsList();

    return () => {
      storeData.Resultclear();
    }
  }, [])

  function getQuestionsList() {
    let userId: any = localStorage.getItem('userID');
    let familyId: any = localStorage.getItem('ownerFamID');

    api.get(`customer/api/v2/hra/families/${encodeURIComponent(familyId)}/survey_assigns/${location.state}`, { headers: { 'userId': userId } })
      .then(res => {
        console.log(res);
        // storeData.setQuestionsList(res.data.data);

        // const tempList = [];
        // for (let i = 0; i < res.data.data.info.length; i++) {
        //   const { category, question } = res.data.data.info[i];
        //   const tempObj: any = {};
        //   tempObj.category = category.name;
        //   tempObj.category_uid = category.uid;
        //   tempObj.category_number = category.number;

        //   tempObj.number = question.number;
        //   tempObj.title = question.title;
        //   tempObj.question_uid = question.uid;
        //   tempObj.type = question.type;

        //   tempObj.strongly_disagree = question.option.strongly_disagree;
        //   tempObj.disagree = question.option.disagree;
        //   tempObj.agree = question.option.agree;
        //   tempObj.strongly_agree = question.option.strongly_agree;

        //   tempList.push(tempObj);
        // }

        // storeData.setQuestionsList(tempList);

        storeData.setViewObject(res.data.data);
        storeData.setFactorsOject(res.data.data.factors);
        storeData.setFamilyOject(res.data.data.family);
        storeData.setIntegrateOject(res.data.data.integrate);
        storeData.setResultOject(res.data.data.result);
      })
      .catch(err => {
        console.log(err);
      });
  }

  // 탭 관련
  function TabPanel(props: any) {
    const { children, value, index, ...other } = props;

    // 탭이 변하면 다시 리랜더링 후 로우스팬 함수 실행
    // useEffect(() => {
    //   if (value === index) {
    //     genRowspan('category');
    //   }
    // }, [value]);

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  }
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const getDamage = () => {
    let data = "";
    if (!!storeData.integrateOject.damage && storeData.integrateOject.damage.data.length != 0) {

      storeData.integrateOject.damage.data.map((item: any, index: any) => {
        if (index == 0) {
          data += item;
        } else {
          data += ', ' + item;
        }
      })
    } else {
      data = "해당없음"
    }
    return <TableCell colSpan={4} sx={{textAlign: 'center'}}>{data}</TableCell>
  }

  const getComorbidity = () => {
    let data = "";
    if (!!storeData.integrateOject.comorbidity && storeData.integrateOject.comorbidity.data.length != 0) {

      storeData.integrateOject.comorbidity.data.map((item: any, index: any) => {
        if (index == 0) {
          data += item;
        } else {
          data += ', ' + item;
        }
      })
    } else {
      data = "해당없음"
    }
    return <TableCell colSpan={4} sx={{textAlign: 'center'}}>{data}</TableCell>
  }

  function getGradeLabel(grade: any) {
    if (!!grade) {
      grade = grade.replace("군", "");
      switch (grade) {
        case "최고위험": return "-high";
        case "고위험": return "-mid-high";
        case "중등도위험": return "-mid";
        case "저위험": return "-mid-low";
        case "최저위험": return "-low";
        default: return null;
      }
    }
  }

  function getGradeLabelBadge(grade: any) {
    return "badge" + getGradeLabel(grade);
  }

  function getGradeLabelText(grade: any) {
    return "txt" + getGradeLabel(grade);
  }

  // function getTdEle(grade: any) {
  //   switch (grade) {
  //     case 'badge-low':
  //       return (<TableCell className="badge-low"><Box sx={{ padding: '1rem .5rem' }}>{storeData.resultOject.grade}</Box></TableCell>)
  //     case 'badge-mid-low':
  //       return (<TableCell className="badge-mid-low"><Box sx={{ padding: '1rem .5rem' }}>{storeData.resultOject.grade}</Box></TableCell>)
  //     case 'badge-mid':
  //       return (<TableCell className="badge-mid-low"><Box sx={{ padding: '1rem .5rem' }}>{storeData.resultOject.grade}</Box></TableCell>)
  //     case 'badge-mid-high':
  //       return (<TableCell className="badge-mid-low"><Box sx={{ padding: '1rem .5rem' }}>{storeData.resultOject.grade}</Box></TableCell>)
  //     case 'badge-high':
  //       return (<TableCell className="badge-mid-low"><Box sx={{ padding: '1rem .5rem' }}>{storeData.resultOject.grade}</Box></TableCell>)
  //     default:
  //       break;
  //   }
  // }

  // 위험요인 평가 maps 데이터 출력
  function getMapsTable(maps: any, isOneScored: any) {
    if (maps !== null && typeof maps !== 'undefined') {
      const entries = Object.entries(maps);
      for (const entry of entries) {
        const key = entry[0];
        const keyString = getKeyString(key);
        const data = entry[1];
        if (data !== null && typeof data !== 'undefined') {
          const result = getTable(keyString, data, isOneScored);
          if (key === "star") {
            // const html = `<td colspan="5">${result}</td>`;
            // const $plus = $(`#${id} .plus`);
            // const $minus = $(`#${id} .minus`);
            // const $space = $(`#${id}-space`);

            // if (maps[key].length === 0 && maps[key].length === 0) {
            //   return (
            //     <TableCell colSpan={5}>{result}</TableCell>
            //   )
            //   // $minus.replaceWith(html);
            //   // $plus.remove();
            //   // $space.remove();
            // } else {
            //   // $(`#${id} .title`).attr("rowspan", 2);
            //   // const target = document.getElementById(id);
            //   // let tr = document.createElement("tr");
            //   // $(tr).attr("id", `${id}-star`);
            //   // tr.innerHTML = html;
            //   // target.parentNode.insertBefore(tr, target.nextSibling);
            //   return (
            //     <TableCell colSpan={5}>{result}</TableCell>
            //   )
            // }

            return (
              <TableCell className="st_thb" colSpan={2}>{result}</TableCell>
            )
          } else {
            // $(`#${id} .${key}`).html(result);
            if (key === 'plus') {
              return (
                <TableCell className="st_thb"  colSpan={2}>{result}</TableCell>
              )
            } else {
              <TableCell className="st_thb"  colSpan={2} sx={{ p: "8px !important"}}>{result}</TableCell>
            }
          }
        }
      }
    }

  }

  function getKeyString(key: any) {
    switch (key) {
      case "plus": case "+": return "+";
      case "minus": case "-": return "-";
      case "star": case "*": return "x";
      default: return null;
    }
  }

  // 위험요인 평가 데이터 출력 (테이블)
  function getTable(key: any, arr: any, isOneScored: any) {
    if (Array.isArray(arr)) {
      // table = '<table class="in-damage">';
      // if( isOneScored === true ) table += `<tr><td class="char"><span class="badge badge-pill badge-${getKeyLabel(key)}">${key}</span></td><td><table>${arr.map( v => `<tr><td>${v}</td></tr>` ).join(" ")}</table></td></tr>`;
      // else if ( isOneScored === false ) table += arr.map( v => `<tr><td class="char"><span class="badge  badge-pill badge-${getKeyLabel(key)}">${key}</span></td><td>${v}</td></tr>` ).join(" ");
      // else table += arr.map( v=> `<tr><td>${v}</td></tr>`).join(" ");
      // table += '</table>';
      if (isOneScored === true) {
        return (
          <Table>
            <TableBody>
              <TableRow>
                <TableCell sx={{width: 55, textAlign:'center', borderRight: '1px dotted #ccc', '& span' : {position: 'relative', top: 5}}}>
                  {
                    key == '+'
                      ? <Typography component='span'><AddCircleIcon sx={{color: '#e90000'}}/></Typography>
                      : key == '-'
                        ? <Typography component='span' ><RemoveCircleIcon sx={{color:'#00aaff'}}/></Typography>
                        : <Typography component='span'><CancelIcon sx={{color:'#919191'}}/></Typography>
                  }
                </TableCell>
                <TableCell>
                  <Table>
                    <TableBody>
                      {
                        arr.map((v: any, idx: any) => {
                          return (
                            <TableRow key={`${v}-${idx}`}>
                              <TableCell>{v}</TableCell>
                            </TableRow>
                          )
                        })
                      }
                    </TableBody>
                  </Table>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )
      } else if (isOneScored === false) {
        return (
          <Table>
            <TableBody>
              {
                arr.map((v: any, idx: any) => {
                  return (
                    <TableRow key={`${v}-${idx}`}>
                      <TableCell sx={{width: 50,'& span' : {position: 'relative', top: 5}}} >
                        {
                          key == '+'
                            ? <Typography component='span'><AddCircleIcon sx={{color: '#e90000'}}/></Typography>
                            : key == '-'
                              ? <Typography component='span'><RemoveCircleIcon sx={{color:'#00aaff'}}/></Typography>
                              : <Typography component='span'><CancelIcon sx={{color:'#919191'}}/></Typography>
                        }
                      </TableCell>
                      <TableCell >
                        {v} asdfasdfasdfasdfasdf
                      </TableCell>
                    </TableRow>
                  )
                })
              }
            </TableBody>
          </Table>
        )
      } else {
        return (
          <Table>
            <TableBody>
              {
                arr.map((v: any, idx: any) => {
                  return (
                    <TableRow key={`${v}-${idx}`}>
                      <TableCell >{v}</TableCell>
                    </TableRow>
                  )
                })
              }
            </TableBody>
          </Table>
        )
      }
    } else {
      return '-';
    }
  }

  // 질환 이력 평가 title 출력
  function getMapsTableTitle(factor: any) {
    let title: any = factor.title;
    if (title !== null && title !== undefined) {
      if (title.indexOf("(") > -1) {
        const character = getKeyString(title.split("(")[1].replace(")", ""));
        // const characterEle = `<span class="badge badge-pill badge-${getKeyLabel(character)}">${character}</span>`;
        // title = `<span style="vertical-align: middle;">${title.split("(")[0]}</span>${characterEle}`;
        return (
          <>
            <Typography component='span'>{title.split("(")[0]}</Typography><br/>
            {
              character == '+'
                ? <Typography component='span'><AddCircleIcon sx={{color: '#e90000'}}/></Typography>
                : character == '-'
                  ? <Typography component='span'><RemoveCircleIcon sx={{color:'#00aaff'}}/></Typography>
                  : <Typography component='span'><CancelIcon sx={{color:'#919191'}}/></Typography>
            }
          </>
        )
      }
    }
  }

  // 질환 이력 평가 grade 출력
  function getMapsTableGrade(factor: any) {
    const grade = factor.grade ? factor.grade : "-";
    return (
      grade
    )
  }

  // 질환 이력 평가 데이터 출력
  function getMapsTableFactors(factor: any) {
    const plain = factor.data;
    const maps = factor.maps;
    const maps_arr = factor.maps_arr;

    if (plain !== null && typeof plain !== 'undefined') {
      if (Array.isArray(plain)) {
        return (
          <Table>
            <TableBody>
              {
                plain.map((v: any, idx: any) => {
                  return (
                    <TableRow key={`${v}-${idx}`}>
                      <TableCell>{v}</TableCell>
                    </TableRow>
                  )
                })
              }
            </TableBody>
          </Table>
        )
      }
    } else if (maps !== null && typeof maps !== 'undefined') {
      const entries = Object.entries(maps);
      for (const entry of entries) {
        const key = entry[0];
        const keyString = getKeyString(key);
        const data = entry[1];
        if (data !== null && typeof data !== 'undefined') {
          if (key === "plus" || key === "inner_title") {
            const table: any = getTableComorbidity(keyString, data);
            return table;
          }
        }
      }
    } else if (maps_arr !== null && typeof maps_arr !== 'undefined') {
      // let innerTable = `<table><tbody>`;
      // let innerContent = '';

      // 해당없음 출력
      maps_arr.map((innerMaps: any) => {
        const entries = Object.entries(innerMaps);
        const entriesLen = entries.length;
        const innerTitle = innerMaps['inner_title'];
        const innerId = getInnerId(innerTitle);

        if (innerId === 'none') {
          // $(`#${id} > .plus`).html(innerMaps['star']);
          return (
            innerMaps['star']
          )
        }
      })

      // maps_arr 데이터 출력
      return (
        <Table>
          <TableBody>
            {
              maps_arr.map((innerMaps: any, idx: any) => {
                const entries = Object.entries(innerMaps);
                const entriesLen = entries.length;
                const innerTitle = innerMaps['inner_title'];
                const innerId = getInnerId(innerTitle);

                if (innerId !== 'none') {
                  for (let i = 0; i < entriesLen; i++) {
                    const entry = entries[i];
                    const key = entry[0];
                    const keyString = getKeyString(key);
                    const data = entry[1];
                    // const innerRowOpen = `<tr id="${innerId}">`;
                    // let innerTitleEle = '';
                    // let innerTableEle = '';
                    // if (data !== null && typeof data !== 'undefined') {
                    //   if (key === "inner_title") innerTitleEle = `<td class="title">${innerTitle}</td>`;
                    //   if (key !== "inner_title") innerTableEle = `<td class="${key}">${getTableComorbidity(keyString, data)}</td>`;
                    // }
                    // const innerRowClose = '</tr>';
                    // innerContent += `${innerRowOpen}${innerTitleEle}${innerTableEle}${innerRowClose}`;
                    return (
                      <TableRow key={`${innerId}-${idx}`}>
                        <TableCell sx={{borderRight: '1px solid #ccc !important'}}>{innerTitle}</TableCell>
                        <TableCell>{getTableComorbidity(keyString, data)}</TableCell>
                      </TableRow>
                    )
                  }
                }
              })
            }
          </TableBody>
        </Table>
      )
    }
  }

  // function getMapsTableWithTitle(id: any, factor: any) {
  //   const plain = factor.data;
  //   const maps = factor.maps;
  //   const maps_arr = factor.maps_arr;
  //   if (plain !== null && typeof plain !== 'undefined') {
  //     if (Array.isArray(plain)) {
  //       // const table = `<table>${plain.map(v => `<tr><td>${v}</td></tr`).join(" ")}></table>`;
  //       // $(`#${id} .plus`).append(table);
  //       return (
  //         <Table>
  //           {
  //             plain.map((v: any, idx: any) => {
  //               return (
  //                 <TableRow key={`${v}-${idx}`}>
  //                   <TableCell>{v}</TableCell>
  //                 </TableRow>
  //               )
  //             })
  //           }
  //         </Table>
  //       )
  //     }
  //   } else if (maps !== null && typeof maps !== 'undefined') {
  //     const entries = Object.entries(maps);
  //     for (const entry of entries) {
  //       const key = entry[0];
  //       const keyString = getKeyString(key);
  //       const data = entry[1];
  //       if (data !== null && typeof data !== 'undefined') {
  //         if (key === "plus" || key === "inner_title") {
  //           const table: any = getTableComorbidity(keyString, data);
  //           // $(`#${id} .${key}`).html(table);
  //           return table;
  //         }
  //       }
  //     }
  //   } else if (maps_arr !== null && typeof maps_arr !== 'undefined') {
  //     let innerTable = `<table><tbody>`;
  //     let innerContent = '';
  //     for (const innerMaps of maps_arr) {
  //       const entries = Object.entries(innerMaps);
  //       const entriesLen = entries.length;
  //       const innerTitle = innerMaps['inner_title'];
  //       const innerId = getInnerId(innerTitle);
  //       if (innerId === 'none') {
  //         $(`#${id} > .plus`).html(innerMaps['star']);

  //         break;
  //       } else {
  //         for (let i = 0; i < entriesLen; i++) {
  //           const entry = entries[i];
  //           const key = entry[0];
  //           const keyString = getKeyString(key);
  //           const data = entry[1];
  //           const innerRowOpen = `<tr id="${innerId}">`;
  //           let innerTitleEle = '';
  //           let innerTableEle = '';
  //           if (data !== null && typeof data !== 'undefined') {
  //             if (key === "inner_title") innerTitleEle = `<td class="title">${innerTitle}</td>`;
  //             if (key !== "inner_title") innerTableEle = `<td class="${key}">${getTableComorbidity(keyString, data)}</td>`;
  //           }
  //           const innerRowClose = '</tr>';
  //           innerContent += `${innerRowOpen}${innerTitleEle}${innerTableEle}${innerRowClose}`;
  //         }
  //       }
  //     }
  //     if (innerContent.length > 0) {
  //       innerTable += `</tbody></tbale>`;
  //       $(`#${id} > .plus`).html(innerTable);
  //     }
  //   }

  //   const grade = factor.grade ? factor.grade : "-";
  //   let title = factor.title;
  //   if (title.indexOf("(") > -1) {
  //     const character = getKeyString(title.split("(")[1].replace(")", ""));
  //     const characterEle = `<span class="badge badge-pill badge-${getKeyLabel(character)}">${character}</span>`;
  //     title = `<span style="vertical-align: middle;">${title.split("(")[0]}</span>${characterEle}`;
  //   }
  //   $(`#${id} > .title`).html(title);
  //   $(`#${id} > .grade`).html(grade).addClass(getGradeLabelText(grade));
  // }

  function getTableComorbidity(key: any, arr: any) {
    // if ( Array.isArray(arr) ) return`<table>${arr.map( v=> `<tr><td>${v}</td></tr>`).join(" ")}</table>`;
    if (Array.isArray(arr)) return <Table><TableBody>{arr.map((v: any, idx: any) => <TableRow key={`${v}-${idx}`}><TableCell sx={{borderBottom: idx !== arr.length-1 ? '1px solid #ccc !important' : ''}}>{v}</TableCell></TableRow>)}</TableBody></Table>
    else return '-';
  }

  function getInnerId(data: any) {
    switch (data) {
      case '뇌혈관질환': return 'cerebro';
      case '심장질환': return 'heart';
      case '혈관질환': return 'vascular';
      default: return 'none';
    }
  }

  function getKeyLabel(key: any) {
    switch (key) {
      case "+": return "danger";
      case "-": return "success";
      case "&times;": case "*": return "secondary";
      default: return null;
    }
  }

  return (
    <Container sx={{ p: { xs: 0, md: 0 }, bgcolor: '#F6F6F6', pb: '60px !important', minHeight: '100vh', minWidth: 320 }}>
      <Box sx={{ bgcolor: '#FFEADF', borderRadius: '0 0 40px 40px', display: 'flex', p: 0, minWidth: 320 }} >
        {/* logo */}
        <Box position={'fixed'} width={'100%'} bgcolor={'#ffeadf'} zIndex={999} maxWidth={'1200px'} >
          <Stack direction={'row'} >
            <Box>
              <ButtonBase sx={{ width: 180, height: 50, ml: 1 }}>
                <Img alt="Dual" src="/dual.png" />
              </ButtonBase>
            </Box>
          </Stack>
        </Box>
        <Grid container spacing={2} direction='row' sx={{ mt: 6, }}>
          <Grid container item xs sx={{ mx: 2, my: 5 }} direction='column' justifyContent='center' alignContent={'center'}>
            <Typography className='topText' sx={{ fontSize: '1.5rem', color: '#FF7863', fontWeight: 900, textAlign: 'center'}}>
            뇌심혈관질환 발병위험도 평가
            </Typography>
            <Typography sx={{ fontSize: '1rem', color: '#EF8322', fontWeight: 500,  textAlign: 'center', mt: 2}} gutterBottom>
            검진결과
            </Typography>
          </Grid>
          
        </Grid>
      </Box>
      
      <Box>
        <Tabs
          className="tab_color"
          value={value}
          id="tab1"
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="wrapped label tabs example"
          sx={{mt: 3, width: '100%', '& button' :{color:'#b7b7b7!important', width: '50%', borderBottom: '1px solid #ccc'}, '& .MuiTabs-indicator' :{bgcolor:'#FF7863!important'}, '& .Mui-selected' :{color:'#FF7863!important', fontWeight:'bold'}}}
        >
          <Tab label="결과요약" {...a11yProps(0)} />
          <Tab label="종합조사표" {...a11yProps(1)} />
        </Tabs>

        <TabPanel value={value} index={0}>
          <Stack sx={{ width: '100%', ml: 'auto', mr: 'auto', mt: 3 }} flexDirection="column" justifyContent={"space-between"}>
            {/* 종합 평가 결과 */}
            <Box className="White_box" sx={{ width: '100%' }}>
              <Typography className="dialogTitle" sx={{boxSizing:'border-box', bgcolor: '#FFEADF', color: '#FF7863', border: '1px solid #FF7863', width: '100%', fontSize: 16, fontWeight: 'bold', textAlign: 'center', p: '8px 0px' }}>{storeData.viewObject && storeData.viewObject.year}년도 종합 평가 결과</Typography>

              <TableContainer>
                <Table size="small" className="Cl_table" sx={{ marginBottom: 3, mt: 3, '& td': { border: '1px solid #ddd'} }}>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ background: '#eeeeee !important', fontWeight: '700', textAlign: 'center' }}>상태</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{p: 1.5}}>{storeData.resultOject.reason && storeData.resultOject.reason.replace('고혈압성질환', '고혈압성질환')}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ background: '#eeeeee !important', fontWeight: '700', textAlign: 'center' }}>결과</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ padding: '0' }} id="integrate-result-msg">
                        <Table sx={{ width: '100%' }}>
                          <TableBody>
                            <TableRow>
                              {/* {
                                storeData.resultOject && getTdEle(getGradeLabelBadge(storeData.resultOject.grade))
                              } */}
                              <TableCell className="badge-low" sx={{bgcolor: '#e16569', textAlign: 'center'}}>{storeData.resultOject.grade == '최저위험군' ? storeData.resultOject.grade : ''}</TableCell>
                              <TableCell className="badge-mid-low" sx={{bgcolor:'#ea913f', textAlign: 'center'}}>{storeData.resultOject.grade == '저위험군' ? storeData.resultOject.grade : ''}</TableCell>
                              <TableCell className="badge-mid" sx={{bgcolor:'#f6e14d', textAlign: 'center'}}>{storeData.resultOject.grade == '중등도위험군' ? storeData.resultOject.grade : ''}</TableCell>
                              <TableCell className="badge-mid-high" sx={{bgcolor:'#aed7ab', textAlign: 'center'}}>{storeData.resultOject.grade == '고위험군' ? storeData.resultOject.grade : ''}</TableCell>
                              <TableCell className="badge-high" sx={{bgcolor:'#67a9c2', textAlign: 'center'}}>{storeData.resultOject.grade == '최고위험군' ? storeData.resultOject.grade : ''}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              <Typography className="dialogTitle" sx={{ boxSizing:'border-box', bgcolor: '#FFEADF', color: '#FF7863', border: '1px solid #FF7863', width: '100%', fontSize: 16, fontWeight: 'bold', textAlign: 'center', p: '8px 0px', mt: 5}}>위험요인 평가</Typography>

              <TableContainer>
                <Table size="small" className="survey_table"
                  sx={{bgcolor: '#fff', mt: 1 , border: '1px solid #ccc !important', 
                        '& td' : {border: '0px solid #ccc', p: '4px 10px 4px 10px'},
                        '& td.st_th' : {textAlign:'center',borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc'},
                        '& .st_thb' : {border: '1px solid #ccc !important'},
                        '& .txt-high' : {color: '#9f003d !important'},
                        '& .txt-mid-high' : {color: '#fa4b00 !important'},
                        '& .txt-mid' : {color: '#ffcc00 !important'},
                        '& .txt-mid-low' : {color: '#5e9a00 !important'},
                        '& .txt-low ' : {color: '#008abb !important'},
                      }}
                >
                  <TableBody>
                    <TableRow>
                      <TableCell className="st_th" sx={{bgcolor: '#eeeeee', textAlign: 'center', p: '10px !important', fontWeight: 700}} colSpan={3}>위험 요인</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="st_th" sx={{textAlign:'center', bgcolor: '#eeeeee'}}>-</TableCell>
                      <TableCell className="st_th" sx={{textAlign:'center' ,bgcolor: '#eeeeee', width: 70}}>발병<br/>위험인자</TableCell>
                      <TableCell className="st_th" sx={{textAlign:'center', bgcolor: '#eeeeee'}}>발병위험완화인자</TableCell>
                    </TableRow>
                    {/* {
                      storeData.factorsOject.additional_risk_factor &&
                        (storeData.factorsOject.additional_risk_factor.gender_age.maps !== null && storeData.factorsOject.additional_risk_factor.gender_age.maps !== undefined)
                        ? getMapsTable(storeData.factorsOject.additional_risk_factor.gender_age.maps)
                        : <TableRow>
                          <TableCell className="st_th">연령 / 성별</TableCell>
                          <TableCell colSpan={5}></TableCell>
                        </TableRow>
                    } */}
                    <TableRow>
                      <TableCell className="st_th" sx={{width: 70, bgcolor: '#eeeeee'}}>연령 / 성별</TableCell>
                      {/* {
                        storeData.factorsOject.additional_risk_factor && Object.keys(storeData.factorsOject.additional_risk_factor.gender_age.maps).map((item: any, idx: any) => {
                          const entries = Object.entries(storeData.factorsOject.additional_risk_factor.gender_age.maps);
                          for (const entry of entries) {
                            const key: any = entry[0];
                            const keyString: any = getKeyString(key);
                            const data: any = entry[1];
                            if (item !== null && item !== undefined) {
                              if (key === 'star') {
                                return (
                                  <TableCell colSpan={5}>
                                    <Typography component='span'>{keyString}</Typography>
                                    {
                                      data.map((v: any) => {
                                        return (
                                          v
                                        )
                                      })
                                    }
                                  </TableCell>
                                )
                              } else {
                                return (
                                  '-'
                                )
                              }
                            }
                          }
                        })
                      } */}
                      {/* <TableCell colSpan={3}></TableCell>
                      <TableCell colSpan={2}></TableCell> */}
                      {
                        storeData.factorsOject.additional_risk_factor && getMapsTable(storeData.factorsOject.additional_risk_factor.gender_age.maps, true)
                      }
                    </TableRow>
                    <TableRow>
                      <TableCell className="st_th" sx={{bgcolor: '#eeeeee'}}>조기발병 /<br />가족력</TableCell>
                      {
                        storeData.factorsOject.additional_risk_factor && getMapsTable(storeData.factorsOject.additional_risk_factor.direct_family_cardio.maps, true)
                      }
                    </TableRow>
                    <TableRow>
                      <TableCell className="st_th" sx={{bgcolor: '#eeeeee'}}>흡연</TableCell>
                      {
                        storeData.factorsOject.additional_risk_factor && getMapsTable(storeData.factorsOject.additional_risk_factor.smoking.maps, true)
                      }
                    </TableRow>
                    <TableRow>
                      <TableCell className="st_th" sx={{bgcolor: '#eeeeee'}}>비만도 /<br />신체활동</TableCell>
                      {
                        storeData.factorsOject.additional_risk_factor && getMapsTable(storeData.factorsOject.additional_risk_factor.obesity_activity.maps, true)
                      }
                    </TableRow>
                    <TableRow>
                      <TableCell className="st_th" sx={{bgcolor: '#eeeeee'}}>혈당</TableCell>
                      {
                        storeData.factorsOject.additional_risk_factor && getMapsTable(storeData.factorsOject.additional_risk_factor.blood_sugar.maps, true)
                      }
                    </TableRow>
                    <TableRow>
                      <TableCell className="st_th" sx={{bgcolor: '#eeeeee',  p: "8px !important"}}>혈중지질</TableCell>
                      {
                        storeData.factorsOject.additional_risk_factor && getMapsTable(storeData.factorsOject.additional_risk_factor.dyslipidemia.maps, false)
                      }
                    </TableRow>
                    <TableRow>
                      <TableCell className="st_th" sx={{bgcolor: '#eeeeee'}}>합계</TableCell>
                      <TableCell colSpan={2} className="st_thb" sx={{textAlign: "center", p: "8px !important"}}>
                        {
                          storeData.factorsOject.additional_risk_factor && storeData.factorsOject.additional_risk_factor.score
                        }
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={3}  sx={{bgcolor: '#eeeeee', textAlign: 'center', p: '10px !important', fontWeight: 700, border: '1px solid #ccc !important'}} >혈압수준</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={2} sx={{borderRight: '1px solid #ccc', textAlign: "center"}} id="hyp-grade" className={`st_th ${storeData.factorsOject.hypertension && getGradeLabelText(storeData.factorsOject.hypertension.grade)}`}>
                        {
                          storeData.factorsOject.hypertension && storeData.factorsOject.hypertension.grade
                        }
                      </TableCell>
                      <TableCell colSpan={1}>
                        
                        {
                          storeData.factorsOject.hypertension && storeData.factorsOject.hypertension.data.map((v: any, idx: any) =>
                            v.indexOf('<br>') > -1
                              ? v.split("<br>").map((vv: any, vidx: any) => <Box key={`${idx}-${vidx}`}>{vv}</Box>)
                              : <Box key={idx}>{v}</Box>
                          )
                        }
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            {/* 질환 이력 평가 */}
            <Box className="White_box" sx={{mt: 5}}>
              <Typography className="dialogTitle" sx={{boxSizing:'border-box', bgcolor: '#FFEADF', color: '#FF7863', border: '1px solid #FF7863', width: '100%', fontSize: 16, fontWeight: 'bold', textAlign: 'center', p: '8px 0px' }}>질환 이력 평가</Typography>
              <TableContainer>
                <Table size="small" className="survey_table" 
                sx={{ mt: 1, height: '100%', border: '1px solid #ccc', bgcolor : '#fff',
                      '& td': {border: "0px solid #333", p: .8, }, 
                      '& span' : {fontSize: 14},
                      '& .st_th, & .title, & .plus' : {border: '1px solid #ccc'},
                      '& .txt-high' : {color: '#9f003d !important'},
                      '& .txt-mid-high' : {color: '#fa4b00 !important'},
                      '& .txt-mid' : {color: '#ffcc00 !important'},
                      '& .txt-mid-low' : {color: '#5e9a00 !important'},
                      '& .txt-low ' : {color: '#008abb !important'},
                      
                    }}
                >
                  <TableBody>
                    <TableRow>
                    <TableCell colSpan={3} className="st_th" sx={{bgcolor:"#eee", textAlign: 'center', p: '10px !important', fontWeight: 700}}>동반질환</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={3} className="st_th" sx={{bgcolor:"#eee", textAlign: 'center'}}>고혈압성 질환단계</TableCell>
                    </TableRow>
                    <TableRow id="comorbidity-diabetes">
                      <TableCell className="title char" sx={{textAlign:'center'}}>
                        {
                          storeData.factorsOject.diabetes && getMapsTableTitle(storeData.factorsOject.diabetes)
                        }
                      </TableCell>
                      <TableCell className="plus star">
                        {
                          storeData.factorsOject.diabetes && getMapsTableFactors(storeData.factorsOject.diabetes)
                        }
                      </TableCell>
                      <TableCell rowSpan={2} className={storeData.factorsOject.diabetes && getGradeLabelText(storeData.factorsOject.diabetes.grade)}> 
                        {storeData.factorsOject.diabetes && getMapsTableGrade(storeData.factorsOject.diabetes)}
                      </TableCell>
                    </TableRow>
                    <TableRow id="comorbidity-diabetes-damage">
                      <TableCell className="title char" sx={{textAlign:'center'}}>
                        {
                          storeData.factorsOject.diabetes_damage && getMapsTableTitle(storeData.factorsOject.diabetes_damage)
                        }
                      </TableCell>
                      <TableCell className="plus star">
                        {
                          storeData.factorsOject.diabetes_damage && getMapsTableFactors(storeData.factorsOject.diabetes_damage)
                        }
                      </TableCell>
                    </TableRow>
                    <TableRow id="comorbidity-hypertensive-damage">{/*단계*/}
                      <TableCell colSpan={3} className="st_th" sx={{bgcolor:"#eee", textAlign: 'center', p: '10px !important'}}>{storeData.factorsOject.hypertension && storeData.factorsOject.hypertension.disease_stage}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="title char" sx={{textAlign:'center'}}>
                        {
                          storeData.factorsOject.hypertensive_damage && getMapsTableTitle(storeData.factorsOject.hypertensive_damage)
                        }
                      </TableCell>
                      <TableCell className="plus star">
                        {
                          storeData.factorsOject.hypertensive_damage && getMapsTableFactors(storeData.factorsOject.hypertensive_damage)
                        }
                      </TableCell>
                      <TableCell sx={{textAlign:'center'}} className={storeData.factorsOject.hypertensive_damage && getGradeLabelText(storeData.factorsOject.hypertensive_damage.grade)}>
                        {storeData.factorsOject.hypertensive_damage && getMapsTableGrade(storeData.factorsOject.hypertensive_damage)}
                      </TableCell>
                    </TableRow>
                    <TableRow id="comorbidity-kidney-disease">
                      <TableCell className="title char" sx={{textAlign:'center'}}>
                        {
                          storeData.factorsOject.kidney_disease && getMapsTableTitle(storeData.factorsOject.kidney_disease)
                        }
                      </TableCell>
                      <TableCell className="plus star">
                        {
                          storeData.factorsOject.kidney_disease && getMapsTableFactors(storeData.factorsOject.kidney_disease)
                        }
                      </TableCell>
                      <TableCell sx={{borderTop:'1px solid #ccc !important', textAlign:'center'}} className={storeData.factorsOject.kidney_disease && getGradeLabelText(storeData.factorsOject.kidney_disease.grade)}>
                        {storeData.factorsOject.kidney_disease && getMapsTableGrade(storeData.factorsOject.kidney_disease)}
                      </TableCell>
                    </TableRow>
                    <TableRow id="comorbidity-cardiovascular-disease">
                      <TableCell className="title char" sx={{textAlign:'center'}}>
                        {
                          storeData.factorsOject.cardiovascular_disease && getMapsTableTitle(storeData.factorsOject.cardiovascular_disease)
                        }
                      </TableCell>
                      <TableCell className="plus star">
                        {
                          storeData.factorsOject.cardiovascular_disease && getMapsTableFactors(storeData.factorsOject.cardiovascular_disease)
                        }
                      </TableCell>
                      <TableCell sx={{borderTop:'1px solid #ccc !important' , textAlign:'center'}} className={storeData.factorsOject.cardiovascular_disease && getGradeLabelText(storeData.factorsOject.cardiovascular_disease.grade)}>
                        {storeData.factorsOject.cardiovascular_disease && getMapsTableGrade(storeData.factorsOject.cardiovascular_disease)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Stack>

          <Divider />

          <Card sx={{textAlign:'left', mt: 2, p: 2, borderRadius: 3}}>
            <Typography sx={{fontWeight:'bold'}}>참고자료</Typography>
            <Typography sx={{fontSize: 12, mt : 1}}>KOSHA GUIDE(H-200-2018) 직장에서의 뇌심혈관계질환 예방을 위한 발병위험도 평가 및 사후관리지침. (한국산업안전보건공단, 2018.)</Typography>
            <Typography sx={{fontSize: 12, mt: 1}}>국가건강검진 건강위험평가(HRA) 개선 정책연구용역사업 최종결과보고서. (질병관리본부, 2017.)</Typography>
          </Card>
        </TabPanel>

        <TabPanel value={value} index={1}>
          {/* 종합조사표 */}
          <Box className="White_box" sx={{ ml: "auto", mr: 'auto' , mt: 3 }}>
            <Typography className="dialogTitle" sx={{ boxSizing:'border-box', bgcolor: '#FFEADF', color: '#FF7863', border: '1px solid #FF7863', width: '100%', fontSize: 16, fontWeight: 'bold', textAlign: 'center', p: '8px 0px' }}>종합조사표</Typography>

            {/* <TableContainer>
              <Table size="small" className="Cl_table" sx={{ marginBottom: 2, mt: 1, '& td': { height: 30 } }}>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ background: '#eeeeee', fontWeight: 'bold', width: 200 }}>이름</TableCell>
                    <TableCell>-</TableCell>

                    <TableCell sx={{ background: '#eeeeee', fontWeight: 'bold', width: 200 }}>사번</TableCell>
                    <TableCell>-</TableCell>

                    <TableCell sx={{ background: '#eeeeee', fontWeight: 'bold', width: 200 }}>검진일</TableCell>
                    <TableCell>-</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <TableContainer>
              <Table size="small" className="survey_table">
                <TableBody>
                  <TableRow>
                    <TableCell className="st_th" rowSpan={17} sx={{ width: 150 }}>발병위험인자</TableCell>
                    <TableCell rowSpan={6} className="st_th" sx={{ width: 150 }}>문진</TableCell>
                    <TableCell className="st_th" sx={{ width: '200px' }}>연령</TableCell>
                    <TableCell colSpan={4}>{'만 ' + '' + ' 세'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="st_th">성별</TableCell>
                    <TableCell colSpan={4}>{'(비고:' + '' + ')'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="st_th">흡연</TableCell>
                    <TableCell colSpan={4}>-</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="st_th">신체활동</TableCell>
                    <TableCell colSpan={4}>-</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell rowSpan={2} className="st_th">가족력</TableCell>
                    <TableCell colSpan={4} className="st_th">직계가족의 심혈관질환 조기발병</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={4}>해당없음</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell rowSpan={9} className="st_th">측정 및 검사</TableCell>
                    <TableCell rowSpan={3} className="st_th">비만도(BMI) 또는 허리둘레</TableCell>
                    <TableCell className="st_th">신장</TableCell>
                    <TableCell sx={{ textAlign: 'right !important' }}>- cm</TableCell>
                    <TableCell className="st_th">체중</TableCell>
                    <TableCell sx={{ textAlign: 'right !important' }}>- kg</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2} className="st_th">Body Mass Index (BMI)</TableCell>
                    <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>- kg/m²</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2} className="st_th">허리둘레</TableCell>
                    <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>cm</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={3} className="st_th">혈압</TableCell>
                    <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{'' + ' / ' + '' + ' mmHg'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell rowSpan={4} className="st_th">혈중지질</TableCell>
                    <TableCell colSpan={2} className="st_th">총콜레스테롤</TableCell>
                    <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{'' + ' mg/dL'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2} className="st_th">HDL콜레스테롤</TableCell>
                    <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{'' + ' mg/dL'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2} className="st_th">중성지방(Triglyceride)</TableCell>
                    <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{'' + ' mg/dL'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2} className="st_th">LDL콜레스테롤</TableCell>
                    <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{'' + ' mg/dL'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="st_th">혈당</TableCell>
                    <TableCell className="st_th" >공복혈당</TableCell>
                    <TableCell sx={{ textAlign: 'right !important' }}>{'' + ' mg/dL'}</TableCell>
                    <TableCell className="st_th">당화혈색소</TableCell>
                    <TableCell sx={{ textAlign: 'right !important' }}>{'' + ' %L'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="st_th" colSpan={2}>표적장기 손상 여부</TableCell>
                    <TableCell colSpan={4}>해당없음</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="st_th" colSpan={2}>동반된 질병상태</TableCell>
                    <TableCell colSpan={4}>해당없음</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer> */}

            <TableContainer>
              <Table size="small" className="" sx={{ marginBottom: 3, mt: 3, border: '1px solid #ccc', '& td': {textAlign: 'center'}, bgcolor:'#fff'  }}>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{ background: '#eeeeee', fontWeight: 'bold' , borderRight: '1px solid #ccc', width: '50%'}}>이름</TableCell>
                    <TableCell sx={{ background: '#eeeeee', fontWeight: 'bold' }}>사번</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{borderRight: '1px solid #ccc', width: '50%'}}>{storeData.familyOject && storeData.familyOject.name}</TableCell>
                    <TableCell>{storeData.familyOject && storeData.familyOject.ownerId}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2} sx={{ background: '#eeeeee', fontWeight: 'bold' }}>검진일</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2}>{storeData.viewObject && storeData.viewObject.inspect_date}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <TableContainer>
              <Table size="small" className="survey_table" sx={{bgcolor:'#fff', '& td' : {p :1, border: '1px solid #ccc'}, '& .st_th' : {bgcolor: '#eeeeee !important', textAlign: 'center'}}}>
                <TableBody>
                  <TableRow>
                    <TableCell className="st_th" colSpan={4} sx={{bgcolor: '#d5d5d5', textAlign:'center', fontWeight: 'bold', p: '10px !important'}}>발병위험인자</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={4} className="st_th" sx={{bgcolor: '#eee', textAlign:'center', fontWeight: 600}} >문진</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1} className="st_th" sx={{ width: 70 }}>연령</TableCell>
                    <TableCell colSpan={3}>{storeData.integrateOject.survey && '만 ' + storeData.integrateOject.survey.age + ' 세'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1} className="st_th">성별</TableCell>
                    <TableCell colSpan={3}>{storeData.integrateOject.survey && storeData.integrateOject.survey.gender + '(비고:' + storeData.integrateOject.survey + ')' && storeData.integrateOject.survey.fh }</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1} className="st_th">흡연</TableCell>
                    <TableCell colSpan={3}>{storeData.integrateOject.survey && storeData.integrateOject.survey.smoking}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1} className="st_th">신체활동</TableCell>
                    <TableCell colSpan={3}>{storeData.integrateOject.survey && storeData.integrateOject.survey.activity}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell rowSpan={2}  colSpan={1} className="st_th">가족력</TableCell>
                    <TableCell colSpan={3}>직계가족의 심혈관질환 조기발병</TableCell>
                  </TableRow>
                  <TableRow>
                    {storeData.integrateOject.survey && storeData.integrateOject.survey.direct_family_cardie ? <TableCell colSpan={2}>{storeData.integrateOject.survey && storeData.integrateOject.survey.direct_family_cardie}</TableCell> : <TableCell colSpan={2}>해당없음</TableCell>}
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={4} className="st_th" sx={{bgcolor:'#eee', textAlign:'center', fontWeight: 600}}>측정 및 검사</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell rowSpan={4} className="st_th">비만도(BMI)<br/>또는<br/>허리둘레</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1} className="st_th">신장</TableCell>
                    {
                      storeData.integrateOject.inspection && storeData.integrateOject.inspection.height
                        ? <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{storeData.viewObject && storeData.integrateOject.inspection.height + ' cm'}</TableCell>
                        : <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>- cm</TableCell>
                    }
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1} className="st_th">체중</TableCell>
                    {
                      storeData.integrateOject.inspection && storeData.integrateOject.inspection.weight
                        ? <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{storeData.viewObject && storeData.integrateOject.inspection.weight + ' kg'}</TableCell>
                        : <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>- kg</TableCell>
                    }
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1} className="st_th">Body Mass Index (BMI)</TableCell>
                    {
                      storeData.integrateOject.inspection && storeData.integrateOject.inspection.bmi
                        ? <TableCell sx={{ textAlign: 'right !important' }}>{storeData.viewObject && storeData.integrateOject.inspection.bmi + ' kg/m²'}</TableCell>
                        : <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>- kg/m²</TableCell>
                    }
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2} className="st_th">허리둘레</TableCell>
                    <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{storeData.integrateOject.inspection && storeData.integrateOject.inspection.waist + ' cm'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={2} className="st_th">혈압</TableCell>
                    <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{storeData.integrateOject.inspection && storeData.integrateOject.inspection.systolic + ' / ' + storeData.viewObject && storeData.integrateOject.inspection.diastolic + ' mmHg'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell rowSpan={4} className="st_th">혈중지질</TableCell>
                    <TableCell colSpan={1} className="st_th">총콜레스테롤</TableCell>
                    <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{storeData.integrateOject.inspection && storeData.integrateOject.inspection.tchol + ' mg/dL'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1} className="st_th">HDL콜레스테롤</TableCell>
                    <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{storeData.integrateOject.inspection && storeData.integrateOject.inspection.hdl + ' mg/dL'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1} className="st_th">중성지방(Triglyceride)</TableCell>
                    <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{storeData.integrateOject.inspection && storeData.integrateOject.inspection.tri + ' mg/dL'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={1} className="st_th">LDL콜레스테롤</TableCell>
                    <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{storeData.integrateOject.inspection && storeData.integrateOject.inspection.ldl + ' mg/dL'}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell rowSpan={2} className="st_th">혈당</TableCell>
                    <TableCell className="st_th">혈당</TableCell>
                      {
                        storeData.integrateOject.inspection && storeData.integrateOject.inspection.glucose
                          ? <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{storeData.viewObject && storeData.integrateOject.inspection.glucose + ' mg/dL'}</TableCell>
                          : <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>- mg/dL</TableCell>
                      }
                    </TableRow>
                    <TableRow>
                      <TableCell className="st_th">당화혈색소</TableCell>
                        {
                          storeData.integrateOject.inspection && storeData.integrateOject.inspection.hba1c
                            ? <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>{storeData.viewObject && storeData.integrateOject.inspection.hba1c + ' %L'}</TableCell>
                            : <TableCell colSpan={2} sx={{ textAlign: 'right !important' }}>- %L</TableCell>
                        }
                    </TableRow>
                    <TableRow>
                      <TableCell className="st_th" colSpan={4} sx={{bgcolor:'#eee', textAlign:'center', fontWeight: 600}}>표적장기 손상 여부</TableCell>
                    </TableRow>
                    <TableRow>
                        {getDamage()}
                    </TableRow>
                    <TableRow>
                      <TableCell className="st_th" colSpan={4} sx={{bgcolor:'#eee', textAlign:'center', fontWeight: 600}}>동반된 질병상태</TableCell>
                    </TableRow>
                    <TableRow>
                      {getComorbidity()}
                    </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </TabPanel>
      </Box>

      <Box sx={{ textAlign: 'center', p :2 }}>
        <Button variant="contained" onClick={() => navigate(-1)} sx={{ mt: 2, mb: 5, background: '#EF8322', borderRadius: 20, width: '100%', '&:hover': { background: '#EF8322' } }}>목록</Button>
      </Box>

      <Bottom />
    </Container>
  )
}


const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}

export default HraResult;